import { Route } from '@angular/router';
import { authGuard } from '../../guards/auth-guard/auth-guard';
import { FamilyPortalLayoutPageComponent } from 'src/app/components/family-portal-layout-page/family-portal-layout-page.component';
import { HomeGuard } from '../../guards/home-guard/home-guard';

export const myAccountRoute: Route = {
  path: 'myaccount',
  component: FamilyPortalLayoutPageComponent,
  loadChildren: () => import('../../../components/my-account/my-account.module').then(m => m.MyAccountModule),
  canActivate: [authGuard, HomeGuard],
};
